/* eslint-disable import/first */
import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import {
  Typography as MuiTypography,
  Divider as MuiDivider,
  Link,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";

/* ---------- styled ---------- */
const Section = styled.section`
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 24px;
  background: #fff;
  margin-bottom: 32px;
`;
const H1 = styled(MuiTypography).attrs({ variant: "h3", component: "h1" })``;
const H2 = styled(MuiTypography).attrs({ variant: "h5", component: "h2" })`
  margin-bottom: 8px;
`;
const Body = styled(MuiTypography).attrs({ variant: "body1" })``;
const List = styled.ul`
  padding-left: 20px;
  margin: 0;
  li {
    margin-bottom: 4px;
  }
`;
const Divider = styled(MuiDivider)(spacing);

/* ---------- component ---------- */
export default function Accessibility() {
  return (
    <>
      <Helmet title="Accessibility" />
      <header>
        <H1 gutterBottom>Accessibility</H1>
        <Divider my={4} />
      </header>

      <main>
        <Section aria-labelledby="commitment">
          <H2 id="commitment">Our Commitment</H2>
          <Body gutterBottom>
            We strive to ensure the Cherry Creek Water Quality Portal is usable
            by everyone. The site is built with modern, semantic HTML,
            responsive design, and is continuously evaluated against the{" "}
            <Link
              href="https://www.w3.org/WAI/WCAG22/quickref/"
              target="_blank"
              rel="noopener noreferrer"
              underline="always"
            >
              Web Content Accessibility Guidelines (WCAG) 2.2 AA
            </Link>
            .
          </Body>
          <Body>
            If you encounter a barrier, <strong>please let us know</strong> —
            we’re dedicated to fixing issues quickly and providing the
            information you need in an accessible format.
          </Body>
        </Section>

        <Section aria-labelledby="contact">
          <H2 id="contact">Contact Us</H2>
          <Body gutterBottom>
            <strong>Need assistance or have feedback?</strong> Reach out and
            we’ll respond in a timely manner.
          </Body>
          <Body component="p">
            Email:{" "}
            <Link
              href="mailto:manager@ccbwqa.org"
              underline="always"
              color="primary"
            >
              manager@ccbwqa.org
            </Link>
          </Body>
          <Body component="p">Phone: 303-968-9098</Body>
        </Section>

        <Section aria-labelledby="efforts">
          <H2 id="efforts">Efforts Toward Digital Accessibility</H2>
          <List>
            <li>
              <Body component="span">
                <strong>Multiple contact methods</strong> for accommodation
                requests
              </Body>
            </li>
            <li>
              <Body component="span">
                <strong>Regular accessibility audits</strong> of portal pages
                and applications
              </Body>
            </li>
            <li>
              <Body component="span">
                <strong>Ongoing remediation</strong> of identified issues and
                user-testing with assistive technology
              </Body>
            </li>
          </List>
        </Section>

        <Section aria-labelledby="linked">
          <H2 id="linked">Linked Documents &amp; Third-Party Content</H2>
          <Body>
            Our site links to resources hosted by third parties that may not
            meet the same <strong>accessibility standards</strong>. While we
            cannot control their content, we’re happy to assist any visitor in
            accessing information referenced on our portal.
          </Body>
        </Section>
      </main>
    </>
  );
}
